// extracted by mini-css-extract-plugin
export default {"container":"ManifestDetailsTable__container-axNvc","content":"ManifestDetailsTable__content-E7zzm"};